import type { CSSProperties, Ref } from 'react';

import { Box } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';
import type { GalleryPhoto } from 'components/marketplace/helpers/galleryPhotos';
import {
  type GalleryBreakpointTier,
  generateGalleryPictureSet,
} from 'components/marketplace/helpers/presizedPhotos';

export type GalleryListingPhotoProps = {
  photo: GalleryPhoto;
  sizes: GalleryBreakpointTier[];
  alt: string;
  lazy?: boolean;
  preload?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
  objectFit?: CSSProperties['objectFit'];
  className?: string;
  imageRef?: Ref<HTMLImageElement>;
  fit?: 'cover' | 'contain';
};

export const GalleryListingPhoto = ({
  photo,
  sizes,
  alt,
  lazy = true,
  preload = false,
  fetchPriority,
  objectFit = 'cover',
  className,
  imageRef,
  fit,
}: GalleryListingPhotoProps) => {
  return (
    <Box className={cn('h-full w-full', className)}>
      {generateGalleryPictureSet({
        photo,
        sizes,
        lazy,
        preload,
        fetchPriority,
        alt,
        objectFit,
        imageRef,
        fit,
      })}
    </Box>
  );
};
